import { createTheme } from '@mui/material';
import palette from './palette';
import typography from './typography';

const theme = createTheme({});

const socotraTheme = createTheme({
	palette,
	components: {
		MuiTextField: {
			defaultProps: {
				variant: 'standard', // default changed as part of material v4 to v5 upgrade.
			},
		},
		MuiFormControl: {
			defaultProps: {
				variant: 'standard', // default changed as part of material v4 to v5 upgrade.
			},
		},
		MuiSelect: {
			defaultProps: {
				variant: 'standard', // default changed as part of material v4 to v5 upgrade.
			},
		},
		MuiCard: {
			defaultProps: {
				elevation: 0,
			},
			styleOverrides: {
				root: {
					border: '1px solid #E6E8EB',
					padding: theme.spacing(2, 2, 2, 2),
				},
			},
		},
		MuiFormLabel: {
			styleOverrides: {
				root: {
					'&$disabled': {
						color: 'rgba(0, 0, 0, 0.54)',
					},
				},
			},
		},
		MuiLink: {
			defaultProps: {
				underline: 'hover', // default changed as part of material v4 to v5 upgrade.
			},
			styleOverrides: {
				root: {
					cursor: 'pointer',
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: 'none',
					whiteSpace: 'nowrap',
				},
			},
		},
		MuiFab: {
			styleOverrides: {
				root: {
					textTransform: 'none',
				},
			},
		},
	},
	typography,
});

export default socotraTheme;
